import React from 'react';
import { HardwareTool } from '../components/HardwareTool';
import ToolHeader from '../components/ToolHeader';

export default function HardwarePage() {
  return (
    <>
      <ToolHeader toolName="Hardware Management" />
      <HardwareTool />
    </>
  );
}
